import { useGlobalEmergencyCall } from '../hooks/useGlobalEmergencyCall'
import { useTranslation } from 'react-i18next'

import { Button, Icon } from '@chakra-ui/react'

import { EmergencyCall } from '@/components/icons'
import { MixpanelDataIProps } from '@/features/incident-drawer'

import { GlobalEmergencyCallModal } from './GlobalEmergencyCallModal'

interface GlobalEmergencyCallButtonIProps {
  mixpanelData?: MixpanelDataIProps
  variant?: string
}

export const GlobalEmergencyCallButton = ({
  mixpanelData,
  variant = 'danger',
  ...props
}: GlobalEmergencyCallButtonIProps) => {
  const { t } = useTranslation()
  const {
    isOpen,
    onClose,
    isLoading,
    emergencyCallCategoryId,
    handleEmergencyButtonClick,
    handleCallClick,
  } = useGlobalEmergencyCall(mixpanelData)

  return (
    <>
      <Button
        _disabled={{
          opacity: 0.4,
          cursor: 'not-allowed',
        }}
        border='none'
        color='white'
        data-testid='GlobalEmergencyCall:button'
        disabled={false}
        fontSize='16px'
        isLoading={isLoading}
        onClick={handleEmergencyButtonClick}
        size='md'
        variant={variant}
        {...props}
        rightIcon={
          <Icon
            as={EmergencyCall}
            boxSize='18px'
            strokeColor='white'
            strokeWidth={4}
          />
        }
      >
        {t('emergency_call:emergency_call')}
      </Button>
      {isOpen && (
        <GlobalEmergencyCallModal
          emergencyCallCategoryId={emergencyCallCategoryId}
          handleOnClick={handleCallClick}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </>
  )
}
